export default {
  "AdviceFigure": "_AdviceFigure_1kx22_1",
  "Tips": "_Tips_1kx22_7"
};import "ni:sha-256;j2bTozswACNyOdnZY_v1vsNtM_METolif56lnv5BfUc";